export type InstructionsChoice = "inherit" | "custom" | "none"

// Must match toBatchCustomInstructions in scheduler/src/services/batches/customInstructions.ts,
// which decides what the batch actually stores; this only predicts it for the status line.
export const resolveInstructionsChoice = (text: string, profileInstructions: string | null | undefined,): InstructionsChoice => 
{
  const trimmed = text.trim()
  if (trimmed === (profileInstructions?.trim() ?? "")) return "inherit"
  return trimmed ? "custom" : "none"
}
